import styled, { css } from "styled-components";
import { Row, Col } from "antd";
import useDatelineTemplateData from "hooks/api/job/dateline/template/useJobDatelineTemplateData";
import ManageDatelineForm from "components/job/index/startJobStep/manageDateline/form";

const ManageDatelineWithTemplate = (props) => {
  const { datelineTemplateId, setDoneCreate } = props;

  const { status: templateDataStatus, data } = useDatelineTemplateData({
    datelineTemplateId: datelineTemplateId,
  });

  return (
    <>
      <StyledChildRow gutter={4}>
        <Col span={24}>
          <StyledContainer>
            <ManageDatelineForm
              template={data?.template}
              status={templateDataStatus}
              setDoneCreate={setDoneCreate}
            />
          </StyledContainer>
        </Col>
      </StyledChildRow>
    </>
  );
};

const StyledChildRow = styled(Row)`
  background-color: ${(props) => props.theme.colors.white};

  ${(props) =>
    props.$newJob &&
    css`
      padding: ${(props) => props.theme.spacing[4]};
    `};
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${(props) => props.theme.spacing[5]};
  max-height: 80vh;
  overflow-y: auto;
`;

export default ManageDatelineWithTemplate;
